import { ActivityCardProps } from "./activity-card-types";
import { ActivityContainer, ImageWrapper, ContentWrapper, BalanceText, FlexContainer } from "./style-components";

const ActivityCard: React.FC<ActivityCardProps> = ({ title, date, image, balance }) => {
    const formatDate = (dateStr: string) => {
        const months = [
            'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
            'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
        ];
        
        const [year, month, day] = dateStr.split('-');
        const monthIndex = parseInt(month) - 1;
        
        return `${day} de ${months[monthIndex]} ${year}`;
    };

    return (
        <ActivityContainer>
            <FlexContainer>
            <ImageWrapper>
                <img 
                    src={image} 
                    alt={title}
                />
            </ImageWrapper>
            <ContentWrapper>
                <h3>{title}</h3>
                <span>{formatDate(date ?? '')}</span>
            </ContentWrapper>
        </FlexContainer>
        <BalanceText $isNegative={balance ? parseFloat(balance) < 0 : undefined}>
            {balance}
        </BalanceText>
    </ActivityContainer>
    );
};

export default ActivityCard;